import { SendRounded } from '@mui/icons-material';
import { IconButtonProps } from '@mui/material';
import React from 'react';
import { StyledIconButton } from './commentInput.style';

interface SubmitIconButtonProps extends IconButtonProps {
  onClick?: () => void;
}

const SubmitIconButton = (props: SubmitIconButtonProps) => {
  return (
    <StyledIconButton {...props}>
      <SendRounded color={!!props.disabled ? 'disabled' : 'primary'} />
    </StyledIconButton>
  );
};

export default SubmitIconButton;
